helpers.hasItems = function(data) {
  data = ko.unwrap(data);
  return data && data.length && data.length > 0;
};
